import React from 'react'
import { Image, Container } from 'react-bootstrap'

const Banner = ({img, children}) => {
  return (
    <div className='position-relative'>
      <Image 
        fluid
        style={{height: "300px", objectFit: "cover", zIndex:"-1"}}
        src={img}  
        className="w-100"
      />
      <div style={{background: "rgba(0,0,0,.6)"}} className='h-100 w-100 position-absolute top-0'>
        <Container>
          <div className='position-absolute text-light top-0 py-5'>
            {children}
          </div>
        </Container>
      </div>
    </div>
  )
}

export default Banner